import { requestJson } from '../../organizer/payment/organizer_payments.api.js';

const API_PREFIX = '/api/method/';

const postMethod = (method, args = {}, opts = {}) =>
  requestJson(`${API_PREFIX}${method}`, {
    method: 'POST',
    body: args ?? {},
    timeout: opts.timeout ?? 15000,
  });

const ensureObjectArg = (value, key) => {
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    return value;
  }
  return { [key]: value };
};

export const registerGuestForTicket = (payload, opts) =>
  postMethod('cita_events.api.event.guest_registration_api.register_guest_for_ticket', payload, opts);

export const createCheckoutForGuest = (payload, opts) =>
  postMethod('cita_events.api.payments.stripe_checkout.create_checkout_for_guest', payload, opts);

export const createCheckoutForTicket = (payload, opts) =>
  postMethod('cita_events.api.payments.stripe_checkout.create_checkout_for_ticket', payload, opts);

// #1076 R2 dead-code removal (2026-06-20): resumeCheckoutForRegistration was the
// API-based in-page resume helper used ONLY by payment-handling.js::resumePayment.
// R2 rerouted that button to NAVIGATE to /checkout/resume/<reg> (the standalone
// page that collects the organizer-terms consent), so this helper now has ZERO
// importers anywhere in the app (verified by repo-wide grep). The backend
// endpoint resume_checkout_for_registration stays reachable via resume.html's
// own inline fetch. Removed to avoid a stale resume surface that could not
// collect terms consent.

export const registerForEvent = (payload, opts) =>
  postMethod('cita_events.api.event.event_user_api.register_for_event', payload, opts);

export const deleteRegistration = (payload, opts) =>
  postMethod(
    'cita_events.api.event.event_user_api.delete_registration',
    ensureObjectArg(payload, 'registration'),
    opts,
  );

export const emailHasAccount = (payload, opts) =>
  postMethod(
    'cita_events.api.event.event_public_api.email_has_account',
    ensureObjectArg(payload, 'email'),
    opts,
  );

